// apps/spa/src/hooks/useAuth.ts
// TanStack Query against /api/auth/me with staleTime Infinity — the auth
// identity does not change during a session, so a single fetch + cache forever
// (or until queryClient.clear() at logout) is correct.
//
// Per RESEARCH OQ #4: TanStack Query (not React Context) for single mental model.

import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api';

export type AuthUser = {
  discordUserId: string;
  username: string;
  avatar: string | null;
};

export function useAuth(): {
  user: AuthUser | undefined;
  isLoading: boolean;
  isError: boolean;
  error: ApiError | undefined;
} {
  const q = useQuery<AuthUser, ApiError>({
    queryKey: ['auth', 'me'],
    queryFn: () => api<AuthUser>('/api/auth/me'),
    staleTime: Infinity,
    retry: false,
  });

  return {
    user: q.data,
    isLoading: q.isLoading,
    isError: q.isError,
    error: q.error ?? undefined,
  };
}
